import { InjectionToken } from "@angular/core";

export interface VisolImportConfig {
  extensions?: string[];
  multiple?: boolean;
  folder?: boolean;
}

export interface VisolExportConfig {
  content: Blob;
  filename?: string;
  /** When true, the system drive (Monitor folder) cannot be browsed into — only its root or a removable drive can be the destination. */
  restrictSystemDriveToRoot?: boolean;
}

export interface IVisolFilePickerService {
  importFiles(config: VisolImportConfig): Promise<File[]>;
  exportFile(config: VisolExportConfig): Promise<void>;
  /** Same as exportFile, but resolves with true when the file was written and false when the user cancelled. */
  exportFileWithResult(config: VisolExportConfig): Promise<boolean>;
}

export const VISOL_FILE_PICKER_SERVICE =
  new InjectionToken<IVisolFilePickerService>('VISOL_FILE_PICKER_SERVICE');
